import { render } from "./SearchPlayground.vue?vue&type=template&id=19d7f7fc&scoped=true"
import script from "./SearchPlayground.vue?vue&type=script&lang=js"
export * from "./SearchPlayground.vue?vue&type=script&lang=js"

import "./SearchPlayground.vue?vue&type=style&index=0&id=19d7f7fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d7f7fc"]])

export default __exports__